{
    "UI_Container_Title": "Configuração completa da conta",
    "UI_Container_Description": "Introduza o seu nome completo e uma palavra-passe para concluir o registo",
    "UI_Name_Placeholder": "Nome completo",
    "UI_Name_Label": "Nome completo",
    "UI_Password_Placeholder": "Palavra-passe",
    "UI_Password_Label": "Palavra-passe",
    "UI_PasswordLengthValidation": "A palavra-passe é demasiado curta",
    "UI_PasswordRequiredValidation": "A palavra-passe não pode estar em branco",
    "UI_PasswordStrengthValidation": "A palavra-passe não é suficientemente forte (certifique-se de que inclui letras maiúsculas e minúsculas, bem como números)",
    "UI_Footer_Server_Error": "Erro do servidor",
    "UI_Footer_Submit_Button": "Enviar",
    "UI_NameRequiredValidation": "Introduza o seu nome",
    "NAME": "UserInvite"
}